export default __webpack_public_path__ + "static/media/LshinpadAFE.547c16a8.svg";